import {FRIEND_REFERAL_URL_PREFIX} from '../../constants/partner';

// Приглашение в лобби — это ДРУЖЕСКАЯ РЕФЕРАЛЬНАЯ ссылка с дописанным
// лобби: {домен}/referal/friend/{userId}/lobby/{lobbyId}. Такая форма
// выбрана намеренно:
//  - для незарегистрированного получателя ссылка остается полноценной
//    реферальной (разбор в App.js берет первый сегмент после префикса и
//    остаток пути игнорирует) — приглашение друга засчитается как обычно;
//  - для уже зарегистрированного добавляется автопереход в лобби.
const LOBBY_INVITE_SEGMENT_NAME = 'lobby';
export const LOBBY_INVITE_URL_SEGMENT = `/${LOBBY_INVITE_SEGMENT_NAME}/`;

// Куда кладется lobbyId из открытой ссылки до момента, когда пользователь
// дойдет до главного меню. Именно sessionStorage, а не localStorage (как у
// самой реферальной метки): приглашение живет минуты, и втащить игрока в
// давно закрытое лобби спустя дни — хуже, чем не втащить вовсе. Вкладку
// переживает, в том числе редиректы авторизации Яндекса
export const LOBBY_INVITE_STORAGE_KEY = 'pendingInviteLobbyId';

/**
 * Ссылка-приглашение в лобби от конкретного игрока.
 *
 * @param {string} inviterReferalCode - ПУБЛИЧНЫЙ реферальный код пригласившего
 *   (auth.friendReferalCode). Именно код, а не id игрока: ссылки уходят в
 *   мессенджеры, а id одновременно служит удостоверением для входа в лобби и
 *   игрового сокета
 * @param {string} lobbyId
 * @param {string} origin - origin приложения (по умолчанию текущий)
 * @returns {string}
 */
export const buildLobbyInviteUrl = (inviterReferalCode, lobbyId, origin = window.location.origin) => {
  return `${origin}${FRIEND_REFERAL_URL_PREFIX}${encodeURIComponent(inviterReferalCode)}`
    + `${LOBBY_INVITE_URL_SEGMENT}${encodeURIComponent(lobbyId)}`;
};

// Идентификатор лобби сервер выдает как Math.random().toString(36).slice(2, 9)
// — строчная латиница с цифрами. Формат проверяется ЖЕСТКО: разобранный из
// ссылки id уходит в путь запроса join, и без проверки подсунутый в ссылку
// '../../что-угодно' превращал бы приглашение в POST на произвольный
// эндпоинт того же origin от имени открывшего ссылку
const LOBBY_ID_PATTERN = /^[a-zA-Z0-9_-]{1,32}$/;

/**
 * lobbyId из пути открытой реферальной ссылки, если он там есть.
 * Разбирает только дружеские ссылки: у партнерских лобби-хвоста не бывает.
 *
 * @param {string} pathname - window.location.pathname
 * @returns {string|null} lobbyId или null, если хвоста нет либо id
 *   не похож на идентификатор лобби
 */
export const parseInviteLobbyIdFromPath = (pathname) => {
  if (!pathname || !pathname.startsWith(FRIEND_REFERAL_URL_PREFIX)) {
    return null;
  }

  // [userId, 'lobby', lobbyId] — пустые сегменты (двойные слеши, слеш в
  // конце) отбрасываются, чтобы .../lobby/ без id не считался приглашением
  const segments = pathname
    .slice(FRIEND_REFERAL_URL_PREFIX.length)
    .split('/')
    .filter(Boolean);

  if (segments.length < 3 || segments[1] !== LOBBY_INVITE_SEGMENT_NAME) {
    return null;
  }

  let lobbyId;
  try {
    lobbyId = decodeURIComponent(segments[2]).trim();
  } catch (e) {
    // Битая escape-последовательность в адресе — ссылка не наша
    return null;
  }

  return LOBBY_ID_PATTERN.test(lobbyId) ? lobbyId : null;
};
